<panel width="auto" maxWidth="1600">
  <h3>{{ title }}</h3>
  <section>
    <p>{{ text }}</p>
    @if (details) {
      <p>{{ details }}</p>
    }
  </section>
  @if (stacktrace) {
    <section>
      <a (click)="toggleStacktrace()">{{ 'notification-popup.toggle-stacktrace' | translate }}</a>
      @if (stacktrace && showStacktrace) {
        <div class="text-block expanded-details">
          Stacktrace:
          @for (trace of stacktrace; track trace) {
            <div [class.own-code]="trace.isOwnCode">{{ trace.text }}</div>
          }
        </div>
      }
    </section>
  }
  <section>
    @for (button of buttons; track button) {
      <button [attr.confirm]="button.type == 'confirm' ? '' : null" [attr.reject]="button.type == 'reject' ? '' : null" [attr.ghost]="button.type == 'ghost' ? '' : null" [ignoreValidation]="true" [label]="button.text | translate" (click)="closeView(button.value)"></button>
    }
  </section>
</panel>
